import { callApi } from "@app/api";
import { schema } from "normalizr";

const slqTestSchema = new schema.Entity("slq_tests", {
}, {
  idAttribute: slqTest => slqTest.id,
});

const slqSchema = new schema.Entity("slqs", {
  slq_tests: [slqTestSchema],
}, {
  idAttribute: slq => slq.id,
});

const objectiveSchema = new schema.Entity("objective", {
  slq: slqSchema,
}, {
  idAttribute: objective => objective.id,
});

const protocolSchema = new schema.Entity("protocols", {
  objective_set: [objectiveSchema],
}, {
  idAttribute: protocol => protocol.id,
});

const agreementSchema = new schema.Entity("agreements", {
}, {
  idAttribute: agreement => agreement.id,
});

export const Schemas = {
  PROTOCOL: protocolSchema,
  PROTOCOL_ARRAY: [protocolSchema],
  OBJECTIVE: objectiveSchema,
  OBJECTIVE_ARRAY: [objectiveSchema],
  SLQ: slqSchema,
  SLQ_ARRAY: [slqSchema],
  AGREEMENT: agreementSchema,
  AGREEMENT_ARRAY: [agreementSchema],
};

export const loadAreaOfNeed = () => callApi("areas_of_need/", {
  method: "GET",
});

export const loadProtocols = () => callApi("protocols/", {
  method: "GET",
}, Schemas.PROTOCOL_ARRAY);

export const loadObjectives = (useSchema = true) => callApi("objectives/", {
  method: "GET",
}, useSchema ? Schemas.OBJECTIVE_ARRAY : null);

export const loadslqs = (useSchema = true) => callApi("slqs/", {
  method: "GET",
}, useSchema ? Schemas.SLQ_ARRAY : null);

export const loadAgreements = () => callApi("agreements/", {
  method: "GET",
}, Schemas.AGREEMENT_ARRAY);

export const loadAgreementFiles = (file) => callApi(`agreement_files/${file}/`, {
  method: "GET",
});
